import { render, staticRenderFns } from "./Estudantes-fora-epoca-cadastro.vue?vue&type=template&id=7039a0e4&scoped=true&"
import script from "./Estudantes-fora-epoca-cadastro.vue?vue&type=script&lang=js&"
export * from "./Estudantes-fora-epoca-cadastro.vue?vue&type=script&lang=js&"
import style0 from "./Estudantes-fora-epoca-cadastro.vue?vue&type=style&index=0&id=7039a0e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7039a0e4",
  null
  
)

export default component.exports